import { TProductRefId } from "@/types/plan";
import { TPlan } from "../types.checkout";

/**
 * Returns the subset of available plan cards that the user currently owns.
 * Pass an empty array for `currentActivePlanIds` when the plan is inactive or paused
 * to get an empty list.
 *
 * @param planCards - All available plan cards from the checkout catalog
 * @param currentActivePlanIds - Product ref IDs of the user's active plans
 */
export function getOwnedPlanList(
  planCards: TPlan[],
  currentActivePlanIds: TProductRefId[],
): TPlan[] {
  return planCards.filter((plan) =>
    currentActivePlanIds.includes(plan.productRefId),
  );
}
